/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { Timeline } from '@mui/lab';
import { TimelineItem } from '@mui/lab';
import { TimelineSeparator } from '@mui/lab';
import { TimelineConnector } from '@mui/lab';
import { TimelineContent } from '@mui/lab';
import { TimelineDot } from '@mui/lab';
import { Grid, Typography } from '@mui/material';
import { fonts, themes } from '../themes/themes';
import i18n from '../themes/i18n';
import { DateField } from '../../components';
import { baseDateFormatting } from '../helper';

interface timelineList {
  event_name?: string;
  event_date?: string;
  event_description?: string;
}

interface timelineListProps {
  timeline: timelineList[];
}

const getColors = () => {
  const allColors = ['primary', 'secondary', 'error', 'success'];
  const a_randomColor = Math.floor(Math.random() * 3) + 0;
  return allColors[a_randomColor];
};
function CustomTimeline({ timeline }: timelineListProps) {
  const last_index = timeline?.length - 1;
  return (
    <div
      style={{
        width: '300px',
      }}
    >
      {timeline.map((list, index) => {
        const is_Color: any = getColors();
        
        return (
          <div key={index}>
            <Grid container>
              {' '}
              <Grid item xs={12}>
                <Timeline>
                  <TimelineItem
                    style={{
                      marginBottom: i18n.language == 'en' ? '-3em' : '',
                    }}
                  >
                    <TimelineSeparator sx={{ marginLeft: '-15em' }}>
                      <TimelineDot color={is_Color} />
                      {last_index == index ? '' : <TimelineConnector />}
                    </TimelineSeparator>
                    <TimelineContent>
                      <Typography
                        component="span"
                        style={{
                          fontFamily: fonts.fontFamily,
                          fontSize: fonts.title,
                          fontWeight: 'bold',
                          color: themes.darkBlue,
                          textTransform: 'capitalize',
                        }}
                      >
                        {list?.event_description}
                      </Typography>
                      <Typography
                        style={{
                          fontFamily: fonts.fontFamily,
                          fontSize: fonts.subtitle,
                          color: themes.greySubtitle,
                        }}
                      >
                        {list?.event_date ? (
                          <DateField
                            value={list?.event_date}
                            format={baseDateFormatting}
                          />
                        ) : null}
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                </Timeline>
              </Grid>
            </Grid>
          </div>
        );
      })}
    </div>
  );
}

export default CustomTimeline;
